import React, { FC } from 'react';
import { ImageSource } from 'types/imageSource';

interface PictureProps {
  source: ImageSource;
}

export const Picture: FC<PictureProps> = ({ source, ...delegated }) => {
  if (source.src === '' || source.fallback === '') return <></>;
  return (
    <picture>
      <source srcSet={source.src} type={'image/webp'} />
      <img src={source.fallback} {...delegated} />
    </picture>
  );
};
